import getWindow from '@loggi/js/get-window';
import getDocument from '@loggi/js/get-document';

export function parseURL(url) {
  const document = getDocument();
  if (document !== null) {
    const parser = document.createElement('a');
    parser.href = url;
    if (!parser.hostname) {
      return null;
    }
    return parser;
  }

  return null;
}

export function getURLParameterByName(name, url = getWindow().location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) {
    return null;
  }

  const value = results[2];
  if (!value) {
    return '';
  }
  return decodeURIComponent(value.replace(/\+/g, ' '));
}
